export const TaskOverhaulLabel = {
  0: 'Nada',
  1: 'Revisión activa',
  2: 'Completa'
}
